/* eslint-disable */

import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Typography from 'material-ui/Typography';
import { withStyles } from 'material-ui/styles';
import green from 'material-ui/colors/green';
import { CircularProgress } from 'material-ui/Progress';
import Grid from 'material-ui/Grid';
import Card, { CardMedia, CardContent } from 'material-ui/Card';
import Button from 'material-ui/Button';
import IconBack from 'material-ui-icons/KeyboardArrowLeft';
import { withRouter } from 'react-router';
import Dropzone from 'react-dropzone';
import moment from 'moment';
import Lottie from 'react-lottie';
import * as animationCheckSuccess from '../assets/lottie/check_success.json';
import * as animationCryingEmoji from '../assets/lottie/crying_emoji.json';
import * as animationEmptyBox from '../assets/lottie/empty_box.json';
import { translate } from 'react-i18next';

import { checkCertificate, resetCheckCertificate } from '../actions';

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'center',
  },
  margin: {
    margin: theme.spacing.unit,
  },
  withoutLabel: {
    marginTop: theme.spacing.unit * 3,
  },
  textField: {
    flexBasis: 200,
  },
  wrapper: {
    margin: theme.spacing.unit,
    position: 'relative',
  },
  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  mySubtitle: {
    color: '#34b2ff',
    fontFamily: 'Inter-Regular',
    fontWeight: 'bold',
    fontSize: 12,
    textTransform: 'none',
  },
  myTitle: {
    color: '#1E2B38',
    fontFamily: 'Inter-Regular',
    fontWeight: 'bold',
    fontSize: 20,
    textTransform: 'none',
  },
});

class CertificateCheck extends React.Component {
  static contextTypes = {
    router: PropTypes.func.isRequired,
  };

  componentDidMount = () => {
    this.props.resetCheckCertificate();
  };

  constructor() {
    super();
    this.state = {
      returnJSON: {
        dataCertificate: {
          assetId: 0,
          coSaved: 0,
          powerInW: 0,
          productionDate: 0,
          txHash: '',
        },
      },
      result: '',
      fileName: '',
    };
  }

  onDrop = async file => {
    this.props.checkCertificate(file);
  };

  handleButtonBack = () => {
    if (!this.props.loading) {
      this.props.history.goBack();
    }
  };

  renderCertificateDetails = () => {
    const {
      classes,
      loadingCertificate,
      currentCertificate,
      isCertificateAuthentic,
      t,
      i18n,
    } = this.props;

    const defaultOptionsSuccess = {
      loop: false,
      autoplay: true,
      animationData: animationCheckSuccess,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    };

    const defaultOptionsFail = {
      loop: true,
      autoplay: true,
      animationData: animationCryingEmoji,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    };

    const defaultOptionsEmpty = {
      loop: true,
      autoplay: true,
      animationData: animationEmptyBox,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    };

    if (loadingCertificate) {
      return (
        <Grid container spacing={24}>
          <Grid item xs={12} sm={24}>
            <Card className={classes.card}>
              <CardContent>
                <Typography className={classes.title} color="textSecondary">
                  <p>
                    <span className={classes.mySubtitleTitle}>
                      {t('Checking your certificate...')}
                    </span>
                  </p>
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      );
    }
    if (
      currentCertificate &&
      currentCertificate._powerInW &&
      isCertificateAuthentic === true
    ) {
      return (
        <Grid container spacing={24}>
          <Grid item xs={12} sm={24}>
            <CardMedia
              className={classes.media}
              image={
                currentCertificate._assetId || currentCertificate._assetId === 0
                  ? process.env.REACT_APP_API_URL +
                    '/static/prod_asset_' +
                    currentCertificate._assetId +
                    '.jpg'
                  : ''
              }
              title=""
            />
            <Card className={classes.card}>
              <CardContent>
                <div>
                  <Lottie
                    options={defaultOptionsSuccess}
                    height={100}
                    width={100}
                  />
                  <span
                    style={{
                      fontWeight: 'bold',
                      color: '#00ca72',
                      fontFamily: 'Inter-Regular',
                    }}
                  >
                    {t('This certificate is authentic')}
                  </span>
                </div>
                <Typography
                  className={classes.title}
                  color="textSecondary"
                  style={{ fontFamily: 'Inter-Regular' }}
                >
                  <p>
                    <span style={{ fontWeight: 'bold' }}>{t('Power')} </span>{' '}
                    {parseInt(
                      currentCertificate._powerInW / 1000,
                      10
                    ).toLocaleString('en-US')}{' '}
                    kWh
                  </p>
                  <p>
                    <span style={{ fontWeight: 'bold' }}>
                      {t('Production date ')}
                    </span>{' '}
                    {moment
                      .unix(currentCertificate._productionDate)
                      .format('YYYY-MM-DD HH:mm')}
                  </p>
                  <p>
                    <span style={{ fontWeight: 'bold' }}>
                      {t('Production asset')}{' '}
                    </span>{' '}
                    {currentCertificate._resourceName}
                  </p>
                  <p>
                    <span style={{ fontWeight: 'bold' }}>
                      {t('Allocated to')}{' '}
                    </span>{' '}
                    {currentCertificate._allocatedTo}
                  </p>
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      );
    }

    if (isCertificateAuthentic === false) {
      return (
        <Grid container spacing={24}>
          <Grid item xs={12} sm={24}>
            <Card className={classes.card}>
              <CardContent>
                <div>
                  <Lottie
                    options={defaultOptionsFail}
                    height={100}
                    width={100}
                  />
                </div>
                <Typography className={classes.title} color="textSecondary">
                  <p
                    style={{ fontWeight: 'bold', fontFamily: 'Inter-Regular' }}
                  >
                    {t('Sorry, we can’t find this certificate')}
                  </p>
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      );
    }

    if (isCertificateAuthentic === 'unknown') {
      return (
        <Grid container spacing={24}>
          <Grid item xs={12} sm={24}>
            <Card className={classes.card}>
              <CardContent>
                <div>
                  <Lottie
                    options={defaultOptionsEmpty}
                    height={100}
                    width={100}
                  />
                </div>
                <Typography className={classes.title} color="textSecondary">
                  <p
                    style={{ fontWeight: 'bold', fontFamily: 'Inter-Regular' }}
                  >
                    {t('No certificate uploaded')}
                  </p>
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      );
    }
  };

  render() {
    //const { classes, username, password, user, passwordVisibility, loading, error, isAuthenticated } = this.props;
    const { classes, loadingCertificate, t } = this.props;
    const buttonClassname = classNames({
      [classes.buttonSuccess]: loadingCertificate,
    });

    return (
      <div
        className={classes.root}
        style={{
          justifyContent: 'center',
          flexWrap: 'nowrap',
          alignItems: 'center',
          alignContent: 'center',
          textAlign: 'center',
          marginTop: 60,
          display: 'inherit',
          height: '100vh',
          padding: 30,
        }}
      >
        <div style={{ clear: 'both' }}>
          <div
            className={classes.wrapper}
            style={{ position: 'fixed', top: 20, left: 20 }}
          >
            <Button
              variant="fab"
              color="primary"
              className={buttonClassname}
              onClick={() => this.handleButtonBack()}
            >
              <IconBack className={classes.extendedIcon} />
            </Button>
          </div>
        </div>
        <div style={{ width: '100%', clear: 'both' }}>
          <Typography variant="display1" gutterBottom>
            <span className={classes.myTitle}>
              {t('Check your certificate')}
            </span>
          </Typography>
          <Typography variant="body1" gutterBottom>
            <span className={classes.mySubtitle}>
              {t("Upload your certificate and check it's authenticity.")}
            </span>
          </Typography>

          <Dropzone
            onDrop={this.onDrop.bind(this)}
            style={{
              width: '100%',
              textAlign: 'center',
              border: '2px #737373 dashed',
              fontSize: 25,
              height: '100%',
              minHeight: 300,
              marginTop: 30,
              backgroundColor: 'rgba(255, 255, 255, .8)',
            }}
            className={classes.dropzone}
            accept="application/pdf"
            disableClick={false}
          >
            <div
              style={{
                justifyContent: 'center',
                flexWrap: 'nowrap',
                alignItems: 'center',
                alignContent: 'center',
                textAlign: 'center',
                marginTop: 120,
                display: 'inherit',
              }}
            >
              <Typography variant="display1" gutterBottom>
                <span className={classes.myTitle}>
                  {t('Drag and drop your certificate here')}
                </span>
              </Typography>
            </div>
            <div className={classes.wrapper}>
              {loadingCertificate && (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              )}
            </div>
          </Dropzone>
          <div
            style={{
              justifyContent: 'left',
              flexWrap: 'nowrap',
              alignItems: 'left',
              marginTop: 20,
            }}
          >
            {this.renderCertificateDetails()}
          </div>
        </div>
      </div>
    );
  }
}

CertificateCheck.contextTypes = {
  router: PropTypes.object,
};
CertificateCheck.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = ({ certificatesReducer, errorReducer, router }) => {
  const {
    loadingCertificate,
    currentCertificate,
    isCertificateAuthentic,
  } = certificatesReducer;
  const { location } = router;
  return {
    loadingCertificate,
    location,
    currentCertificate,
    isCertificateAuthentic,
  };
};

const mapDispatchToProps = {
  checkCertificate,
  resetCheckCertificate,
};

CertificateCheck = withStyles(styles, { name: 'CertificateCheck' })(
  CertificateCheck
);
CertificateCheck = translate('translations')(CertificateCheck);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CertificateCheck)
);



// WEBPACK FOOTER //
// ./src/components/CertificateCheck.js